import { getI18nFromGeneral } from '../tools/tools';

const i18n = {
  'general.content.carousel': getI18nFromGeneral('general.hOCTitle.carousel'),
  'general.content.animation': getI18nFromGeneral('general.sider.animation'),
  'general.content.tab': getI18nFromGeneral('general.sider.tabbar'),
  'general.content.products': getI18nFromGeneral('general.sider.products'),
  'general.content.content': getI18nFromGeneral('general.sider.content'),
  'content.carouseltype.image': getI18nFromGeneral(
    'general.tools_helper.image',
  ),
  'general.content.product': getI18nFromGeneral(
    'general.storeCommunicationSetting.product',
  ),
  'content.carouseltype.content': getI18nFromGeneral(
    'general.sider.contentPage',
  ),

  'general.content.none': getI18nFromGeneral('general.status.none'),
  'general.backgroundtype.none': getI18nFromGeneral('general.status.none'),
  'general.layer.image': getI18nFromGeneral('general.tools_helper.image'),
  'general.layer.button': getI18nFromGeneral('general.sider.button'),
  'general.label.product': getI18nFromGeneral(
    'general.storeCommunicationSetting.product',
  ),
  'general.label.content': getI18nFromGeneral('general.sider.contentPage'),
  'general.postergap.none': getI18nFromGeneral('general.status.none'),
  'general.content.moduleStyle': getI18nFromGeneral(
    'general.content.moduleStyle',
  ),
  'general.content.images': getI18nFromGeneral('general.content.images'),
  'general.content.grid': getI18nFromGeneral('general.content.grid'),
  'general.content.contents': getI18nFromGeneral(
    'general.content.contentPages',
  ),
  'general.content.text': getI18nFromGeneral('general.content.text'),
  'general.content.poster': getI18nFromGeneral('general.content.poster'),

  'general.content.contentPageGrid': getI18nFromGeneral(
    'general.content.contentPageGrid',
  ),
  'general.content.productGrid': getI18nFromGeneral(
    'general.content.productGrid',
  ),

  'general.content.tabstyle': getI18nFromGeneral('general.content.tabStyle'),
  'general.content.tabSetting': getI18nFromGeneral(
    'general.content.tabBarSettings',
  ),
  'content.carouseltype.product': getI18nFromGeneral(
    'general.carouseltype.productPage',
  ),
  'general.content.fullWidth': getI18nFromGeneral('general.content.fullWidth'),
  'general.content.wideWidth': getI18nFromGeneral('general.content.wideWidth'),
  'general.content.fixed': getI18nFromGeneral('general.content.fixedHeight'),
  'general.content.scalable': getI18nFromGeneral(
    'general.content.scaleHeightBasedOnModuleWidth',
  ),
  'general.backgroundtype.colour': getI18nFromGeneral(
    'general.backgroundtype.colour',
  ),
  'general.content.PC': getI18nFromGeneral('general.content.pC'),
  'general.content.TABLET': getI18nFromGeneral('general.content.tablet'),
  'general.content.MOBILE': getI18nFromGeneral('general.content.mobile'),
  'general.layer.text': getI18nFromGeneral('general.content.text'),
  'general.producttoshow.one': getI18nFromGeneral(
    'general.producttoshow.onetypeOnScreen',
  ),
  'general.producttoshow.twoportrait': getI18nFromGeneral(
    'general.producttoshow.twotypesOnScreenPortrait',
  ),
  'general.producttoshow.twolandscape': getI18nFromGeneral(
    'general.producttoshow.twotypesOnScreenLandscape',
  ),
  'general.producttoshow.three': getI18nFromGeneral(
    'general.producttoshow.threetypesOnScreen',
  ),
  'general.producttoshow.four': getI18nFromGeneral(
    'general.producttoshow.fourtypesOnScreen',
  ),
  'general.producttoshow.five': getI18nFromGeneral(
    'general.producttoshow.fivetypesOnScreen',
  ),
  'general.producttoshow.six': getI18nFromGeneral(
    'general.producttoshow.sixtypesOnScreen',
  ),
  'general.scrollout.one': getI18nFromGeneral(
    'general.scrollout.onetypeEachScroll',
  ),
  'general.scrollout.two': getI18nFromGeneral(
    'general.scrollout.twotypesEachScroll',
  ),
  'general.scrollout.three': getI18nFromGeneral(
    'general.scrollout.threetypesEachScroll',
  ),
  'general.scrollout.four': getI18nFromGeneral(
    'general.scrollout.fourtypesEachScroll',
  ),
  'general.scrollout.five': getI18nFromGeneral(
    'general.scrollout.fivetypesEachScroll',
  ),
  'general.scrollout.six': getI18nFromGeneral(
    'general.scrollout.sixtypesEachScroll',
  ),
  'general.postergap.small': getI18nFromGeneral('general.postergap.small'),
  'general.postergap.middle': getI18nFromGeneral('general.postergap.middle'),
  'general.postergap.large': getI18nFromGeneral('general.postergap.large'),
  'general.postertype.one': getI18nFromGeneral('general.postertype.onePoster'),
  'general.postertype.five': getI18nFromGeneral('general.postertype.fiveInOne'),
  'general.postertype.twoinone1': getI18nFromGeneral(
    'general.postertype.twoInOne11',
  ),
  'general.postertype.twoinone2': getI18nFromGeneral(
    'general.postertype.twoInOne12',
  ),
  'general.postertype.twoinone3': getI18nFromGeneral(
    'general.postertype.twoInOne21',
  ),
  'general.postertype.three': getI18nFromGeneral(
    'general.postertype.threeInOne',
  ),
  'general.postertype.four': getI18nFromGeneral('general.postertype.fourInOne'),
  'general.postertype.six': getI18nFromGeneral('general.postertype.sixInOne'),
  'general.productinrow.one': getI18nFromGeneral(
    'general.content.onetypeInARow',
  ),
  'general.productinrow.two': getI18nFromGeneral(
    'general.content.twotypesInARow',
  ),
  'general.productinrow.twoportrait': getI18nFromGeneral(
    'general.content.twotypesInARowPortrait',
  ),
  'general.productinrow.twolandscape': getI18nFromGeneral(
    'general.content.twotypesInARowLandscape',
  ),
  'general.productinrow.three': getI18nFromGeneral(
    'general.content.threetypesInARow',
  ),
  'general.productinrow.four': getI18nFromGeneral(
    'general.content.fourtypesInARow',
  ),
  'general.productinrow.five': getI18nFromGeneral(
    'general.content.fivetypesInARow',
  ),
  'general.productinrow.six': getI18nFromGeneral(
    'general.content.sixtypesInARow',
  ),
  'general.overflow.carousel': getI18nFromGeneral(
    'general.content.convertToCarousel',
  ),
  'general.overflow.anotherline': getI18nFromGeneral(
    'general.content.shiftToAnotherLine',
  ),
  'general.overflow.hide': getI18nFromGeneral('general.content.hide'),
  'general.content.iframelink': getI18nFromGeneral(
    'general.content.iframelink',
  ),
  'general.content.moduleHeight': getI18nFromGeneral(
    'general.content.moduleHeight',
  ),
  'general.content.iframe': getI18nFromGeneral('general.content.iframe'),
};

export default i18n;
